import { QueryClient } from '@tanstack/react-query';

/** One QueryClient owns all server state (ADR-0002). Live keys are kept fresh by
 * subscriptions, so retries/refetch-on-focus are disabled for them by default. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});
